<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div style="display: flex; justify-content: flex-start;">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="main" ref="element" :style="{ height: `${elementHeight}px` }">
              <div class="waiting-text-one" style="line-height: 160px;margin-top:60px">{{$t('youBookingIsConfirming')}}</div>
              <div class="waiting-text-two" style="line-height: 160px;">{{$t('pleaseDoNotCLoseYourBrowserClickBackButton')}}</div>
            </div>
            <!--    <div class="demo"><img src="/static/img/waitingNew.svg" alt="" style="width: 100%;height: 25vh;"></div>-->
            <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
            <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
</el-container>
</template>

<script>
import { orderPayment } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import frameNetwork from '@/components/public/frameNetwork'
import publicMask from '@/components/public/publicMask'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'Waiting',
  components: {
    publicFooter,
    publicHeader,
    frameNetwork,
    publicMask,
    publicMenu
  },
  data () {
    return {
      currencyShow: false, // 币种是否显示
      language: this.common.languageSet(this),
      fullscreenLoading: true,
      frameNetworkDialog: false, // 网络异常
      contentWidth: document.body.clientWidth - 74,
      isCollapse: this.common.collapseSet(),
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      elementHeight: document.documentElement.clientHeight,
      source: ''
    }
  },
  created () {
    var params = this.$route.params
    var orderData = localStorage.getItem('orderData')
    if (JSON.stringify(params) === '{}' && orderData !== '{}') {
      params = JSON.parse(orderData)
    }
    if (this.$route.query.paymentOn === 'pingpong') {
      this.pingpongJumpOver()
    } else if (params.paymentSkipUrl === '' || params.paymentSkipUrl === null || params.paymentSkipUrl === undefined) {
      this.waitingShow()
    } else {
      var paymentList = document.querySelectorAll('#paymentALink')
      if (paymentList.length > 0) {
        paymentList[0].remove()
      }
      // 当前页面跳转
      window.location.href = params.paymentSkipUrl
    }
  },
  watch: {
    language: function (newCur, oldCur) {
      // this.pageShow()
    }
  },
  mounted () {
    var source = this.$route.query.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    hotelLanguage (language) {
      this.language = language
    },
    waitingShow: function () {
      let locationHref = window.document.location.href
      var paymentList = document.querySelectorAll('#paymentALink')
      if (paymentList.length > 0) {
        paymentList[0].remove()
      }

      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var language = this.common.languageSet(this)

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var payData = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'orderno': params.orderno,
        'language': language,
        'currency': currency,
        'sessionid': sessionid,
        'operation': 'paymentOrderData',
        'time': time
      }
      var payDataJson = this.common.encryptionData(payData, this)
      orderPayment(payDataJson).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (res.flag === '003') {
          this.frameNetworkDialog = true
        } else if (res.flag === '157') {
          // 回填数据失败
          this.frameNetworkDialog = true
        } else if (res.flag === '167') {
          // 支付失败
          this.frameNetworkDialog = true
        } else if (res.flag === '200') {
          window.location.href = res.data.url
        }
      })
    },
    // pingpong 支付结果
    pingpongJumpOver: function () {
      // 支付成功 请求回调接口
      // 历史信息
      var orderno = this.$route.query.orderno
      var source = this.$route.query.source
      var sessionid = this.$route.query.sessionid

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var time = parseInt(new Date().getTime() / 1000)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=pingpong&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=pingpong'
    }
  }
}
</script>

<style scoped>
.el-main {
    background-color: rgba(240, 242, 245, 1);
    color: #333;
    text-align: center;
    height: calc(100vh - 230px);
  }
.main-mobile{background-color: #FFFBE6;text-align: center;height:100vh;line-height:100vh;}
.main {
    width:50%;
    /* height: 115px; */
    /* line-height: 115px; */
    margin: 7% auto;
}
.text{
    height:45px;

}

.demo img{width:150px;}
.waiting-text-one {
  color:#5366A3;
  height:62px;
  font-size: 24px;
  font-style: normal;
  font-weight:650;
}

.waiting-text-two{
  color:#5366A3;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
}

</style>



// WEBPACK FOOTER //
// src/components/order/Waiting.vue